import React from 'react';
import { useForm } from 'react-hook-form';
import { Card, CardBody, CardHeader, Col, Form, Row } from 'reactstrap';
import { H5, Btn, UL, LI, Image } from '../../../AbstractElements';
import { BankNameOption, EmiTitle, SelectCardOption, SelectDurationOption, Submit } from '../../../Constant';

import Master from '../../../assets/images/ecommerce/mastercard.png';
import Visa from '../../../assets/images/ecommerce/visa.png';
import Paypal from '../../../assets/images/ecommerce/paypal.png';
import InputControl from '../../Common/FormInputs/InputControl';

const Emi = () => {
  const {
    register,
    control,
    formState: { errors },
  } = useForm();

 
  return (
    <>
      <Col xl='4' lg='6' className='box-col-33 debit-card '>
        <Card>
          <CardHeader className='pb-0'>
            <H5>{EmiTitle}</H5>
          </CardHeader>
          <CardBody>
            <Form className='theme-form' >
              <Row>
                <Col sm='6' className='p-r-0'>
                  <InputControl label={false} controlInput='input' className='form-control' type='text' errors={errors} register={{ ...register('first_name', { required: 'is Required.' }) }} />
                </Col>
                <Col sm='6'>
                  <InputControl label={false} controlInput='input' className='form-control' type='text' errors={errors} register={{ ...register('last_name', { required: 'is Required.' }) }} />
                </Col>
                <Col sm='6' className='p-r-0'>
                  <InputControl label={false} controlInput='input' className='form-control' type='number' errors={errors} register={{ ...register('pin_code', { required: 'is Required.', maxLength: 6, minLength: 6 }) }} />
                </Col>
                <Col sm='6'>
                  <InputControl label={false} control={control} controlInput='select' placeholder='Bank Name' options={BankNameOption} className='form-select' errors={errors} register={{ ...register('bank_name', { required: 'is Required.' }) }} />
                </Col>
                <Col sm='12'>
                  <InputControl label={false} control={control} controlInput='select' placeholder='Select Card' options={SelectCardOption} className='form-select' errors={errors} register={{ ...register('select_card', { required: 'is Required.' }) }} />
                </Col>
                <Col sm='12'>
                  <InputControl label={false} control={control} controlInput='select' placeholder='Select Duration' options={SelectDurationOption} className='form-select' errors={errors} register={{ ...register('select_duration', { required: 'is Required.' }) }} />
                </Col>
                <Col sm='12' className='mb-3'>
                  <UL className='payment-opt'>
                    <LI>
                      <Image style={{ width: 'auto' }} src={Master} alt='' />
                    </LI>
                    <LI>
                      <Image style={{ width: 'auto' }} src={Visa} alt='' />
                    </LI>
                    <LI>
                      <Image style={{ width: 'auto' }} src={Paypal} alt='' />
                    </LI>
                  </UL>
                </Col>

                <Col sm='12'>
                  <Btn color='primary' className='btn-block' type='submit'>
                    {Submit}
                  </Btn>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

export default Emi;
